// extracted by mini-css-extract-plugin
export default {"chargeBacks-wrapper":"ChargeBacks_chargeBacks-wrapper__9kkFb"};